const { ONEWAY, ROUNDTRIP, OPENJAW } = require('./product/constants');

/* Booleans for products */
const isOpenjaw = value => value.toLowerCase() === OPENJAW;
const isOneway = value => value.toLowerCase() === ONEWAY;
const isRoundtrip = value => value.toLowerCase() === ROUNDTRIP;

/**
 * Function to format the date
 * @param {object} date Object containing the date
 * @returns {string} Date in format yyyy-mm-dd
 */
function formatDate(date) {
    const d = new Date(date);

    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return `${[year, month, day].join('-')}`;
}

module.exports = {
    isOpenjaw,
    isOneway,
    isRoundtrip,
    formatDate
};
